<div *ngIf="showLoading" class="flexCenter">
    <mat-spinner></mat-spinner>
</div>

<mat-tab-group mat-stretch-tabs *ngIf="!showLoading">
    <mat-tab [label]="this.translateResourceDefinition.transform('REQDETAILS', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', 'LOGIN')">
        <app-formular [formBuilderInput]="modelInput" [formular]="formular1" (action)="action($event)" [groupName]="groupName"></app-formular>


        <app-grid-template [columns]="columnsAssets" [urlString]="gridAssetsDataUrl" [enableHideEmpty]="true" [defaultFilter]="gridAssetsDataUrlDefaultFilter" [title]="'ASSETS'" (action)="gridAction($event)"></app-grid-template>

        <app-grid-template [columns]="MS_REQCASSET_NColumns" [urlString]="MS_REQCASSET_NUrlString" [enableHideEmpty]="true" [title]="'CRITICALASSETS'" (action)="gridAction($event)"></app-grid-template>

        <app-formular [formBuilderInput]="modelInput" [formular]="formular2" (action)="action($event)"></app-formular>
    </mat-tab>
    <mat-tab [label]="this.translateResourceDefinition.transform('cptn_UploadedFiles', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', 'LOGIN')">
        <app-formular [formBuilderInput]="modelInput" [formular]="formular3" (action)="action($event)"></app-formular>
        <button type="button" mat-raised-button (click)="fileInput.click()" on>
        {{"btn_chooseFile" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </button>
        <input hidden (change)="handleFileInput($event.target.files)" (input)="onInput()" #fileInput type="file" id="file">
        <button mat-raised-button (click)="upload()">
        {{"btn_upload" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </button>
        <br>
        <br>

        <app-grid-template [columns]="columnsRequestDocument" [urlString]="gridRequestDocumentDataUrl" [enableHideEmpty]="true" [title]="'cptn_UploadedFiles'" [defaultFilter]="gridRequestDocumentDataUrlDefaultFilter" (action)="gridAction($event)" [groupName]="groupName"></app-grid-template>
    </mat-tab>
</mat-tab-group>
<div *ngIf="!showLoading">
    <button mat-raised-button (click)="forward()">{{"btn_forward" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    <button mat-raised-button (click)="back()">{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    <button mat-raised-button (click)="searchAttribute()">{{"btn_searchAtribute" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
</div>